import { Paintbrush, Palette, Type, AlignLeft, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function CustomizationContent({
  editAccentColor, setEditAccentColor,
  editWelcomeText, setEditWelcomeText,
  editFooterText, setEditFooterText,
  saveSiteSettings, isSavingConfig
}) {
  return (
    <div className="p-4 sm:p-6 max-w-2xl mx-auto">
      <h2 className="text-lg font-bold text-white mb-6 flex items-center gap-2">
        <Paintbrush className="w-5 h-5 text-purple-500" />
        Personnalisation
      </h2>

      <div className="space-y-6">
        {/* Accent Color */}
        <div className="bg-zinc-900/30 backdrop-blur-sm border border-zinc-800/50 rounded-xl p-4">
          <label className="text-sm text-zinc-400 mb-2 block flex items-center gap-2">
            <Palette className="w-4 h-4 text-purple-400" />
            Couleur d'accentuation
          </label>
          <div className="flex items-center gap-3">
            <input
              type="color"
              value={editAccentColor}
              onChange={(e) => setEditAccentColor(e.target.value)}
              className="w-10 h-10 rounded border border-zinc-700 bg-transparent cursor-pointer"
            />
            <Input
              value={editAccentColor}
              onChange={(e) => setEditAccentColor(e.target.value)}
              className="bg-zinc-800 border-zinc-700 text-white font-mono w-32"
              placeholder="#00f0ff"
            />
            <div className="w-8 h-8 rounded" style={{ backgroundColor: editAccentColor }} />
          </div>
        </div>

        {/* Welcome Text */}
        <div className="bg-zinc-900/30 backdrop-blur-sm border border-zinc-800/50 rounded-xl p-4">
          <label className="text-sm text-zinc-400 mb-2 block flex items-center gap-2">
            <Type className="w-4 h-4 text-purple-400" />
            Texte d'accueil
          </label>
          <textarea
            value={editWelcomeText}
            onChange={(e) => setEditWelcomeText(e.target.value)}
            className="w-full bg-zinc-800 border border-zinc-700 text-white rounded-md px-3 py-2 text-sm font-mono min-h-[80px] resize-y focus:outline-none focus:ring-1 focus:ring-purple-500"
            placeholder="Texte affiché sur la page d'accueil avant de générer un email..."
          />
          <p className="text-xs text-zinc-600 mt-1">Affiché au-dessus du bouton "Générer" quand aucun email n'est actif</p>
        </div>

        {/* Footer Text */}
        <div className="bg-zinc-900/30 backdrop-blur-sm border border-zinc-800/50 rounded-xl p-4">
          <label className="text-sm text-zinc-400 mb-2 block flex items-center gap-2">
            <AlignLeft className="w-4 h-4 text-purple-400" />
            Texte du footer
          </label>
          <textarea
            value={editFooterText}
            onChange={(e) => setEditFooterText(e.target.value)}
            className="w-full bg-zinc-800 border border-zinc-700 text-white rounded-md px-3 py-2 text-sm font-mono min-h-[80px] resize-y focus:outline-none focus:ring-1 focus:ring-purple-500"
            placeholder="Vos données sont automatiquement supprimées après expiration. Aucune collecte personnelle."
          />
          <p className="text-xs text-zinc-600 mt-1">Texte affiché en bas de page. Laissez vide pour le message par défaut.</p>
        </div>

        {/* Save */}
        <Button
          onClick={saveSiteSettings}
          disabled={isSavingConfig}
          className="w-full bg-purple-500 hover:bg-purple-600 text-white font-medium"
        >
          <Save className="w-4 h-4 mr-2" />
          {isSavingConfig ? "Sauvegarde..." : "Sauvegarder la personnalisation"}
        </Button>
      </div>
    </div>
  );
}
